{
	"title": "Invoices",
	"buttonShowMoreInvoicesTitle": "Show more invoices",
	"invoicesTableHeaders": {
		"date": "Date",
		"invoiceNumber": "Invoice number",
		"deliveredQuantity": "Delivered quantity",
		"bundledCarbonSavings": "Bundled carbon reductions",
		"transactionId": "Transaction ID"
	},
	"errorMessage": "Failed to load invoices"
}
